

















import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class Header extends Vue {
    private theme = false
    search = ''

    toggleNav(){
        this.$store.commit('setSideNav')
    }
    changeTheme() {
        if (this.theme === false) {
            document.documentElement.setAttribute('data-theme', 'dark')
        } else {
            document.documentElement.setAttribute('data-theme', 'light')
        }
        window.localStorage.setItem('theme', this.theme?'true':'false')
    }

    searchAction () {
        const path = '/search/'+this.search
        if (this.$route.path !== path) {
            this.$router.push(path)
        }
    }

    mounted() {
        if (window.localStorage.getItem('theme') === 'false') {
            document.documentElement.setAttribute('data-theme', 'dark')
            this.theme = false
        } else {
            document.documentElement.setAttribute('data-theme', 'light')
            this.theme = true
        }
    }
}
